import { styled, ButtonBase, css } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { LinkProps } from 'react-router-dom';
import Offer from 'components/OfferCard';
import { StyledCard as OfferCard } from 'components/OfferCard/OfferCard.styles';
import Carousel from 'components/Carousel';

export const StyledButton = styled(ButtonBase)<LinkProps>`
  -webkit-touch-callout: none;
  -webkit-user-drag: none;
`;

const commonCardStyles = css`
  cursor: pointer;
  height: auto;
  min-width: 200px;
`;

export const StyledOffer = styled(Offer)`
  ${commonCardStyles};

  ${({ theme }) => theme.breakpoints.down('md')} {
    &:first-of-type {
      margin-left: 1rem;
    }
  }
`;

export const StyledOfferCard = styled(OfferCard)`
  ${commonCardStyles};

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-right: 1rem;
  }
`;

export const StyledArrowIcon = styled(ArrowForwardIcon)``;

export const StyledCarousel = styled(Carousel)`
  padding: 1.2rem 0 2rem;
`;
